define.alias("shared/components/shared/desktop-only-banner", "settings/components/shared/desktop-only-banner");